import { toast } from "react-toastify";
import { timeToast } from "../../../../Constant";
import { getItemCreateSuccessMsg } from "../../../../Constant/Message";

toast.configure();

const getExportUMO = async (axiosInstance, formData) => {
  // console.log('masuk')
  return await axiosInstance
  .post("umo/export/", formData, {
    responseType: 'blob' // Add this line to handle binary data correctly
  })
  .catch((error) => {
    console.error(error);
    toast.error(`GET (UMO) ${error.message}`, {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: timeToast,
    });
  });
};

export default getExportUMO;
